import { Environment } from 'utils/Enums';

/**
 * Developer fallback gate. Returns true ONLY when the opt-in flag is set AND the
 * runtime environment is dev/stage/test. This is a developer tool (work ahead of
 * the backend), never a production resilience path - the env check makes a prod
 * fallback structurally impossible even if the flag leaks into a prod build.
 *
 * Not named `use*` deliberately: it is a plain predicate, not a React hook, and
 * is called from inside the query function.
 */
const FALLBACK_ALLOWED_ENVS = new Set<string>([Environment.dev, Environment.staging, Environment.test]);

export const shouldUseFallbackConfig = (): boolean => {
    // return true;
    if (process.env.REACT_APP_TPO_GEN_USE_FALLBACK_CONFIG !== 'true') return false;
    const env = process.env.REACT_APP_CUSTOMER_ENV || Environment.staging;
    return FALLBACK_ALLOWED_ENVS.has(env);
};
